
import { ConfigModule } from '~/store/modules/config';
import { Component, Vue } from 'vue-property-decorator';
import TheTreeMenu from '~/components/TheTreeMenu/index.vue';
import { UserModule } from '~/store/modules/user';

@Component({
    components: {
        TheTreeMenu,
    },

})
export default class TheLeftPanel extends Vue {
    showEmail = false;

    get mail() {
        return UserModule.userMail;
    }

    get prefix() {
        return UserModule.prefix;
    }

    goToUserView() {
        const pathParticle = UserModule.env === 'eliot' ? 'eliotuser' : 'user';
        this.$router.push(`/${ConfigModule.supportAppNameBase}/${pathParticle}/${encodeURIComponent(this.prefix + this.mail)}`);
    }
}
